import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDenoComponent } from './simple-icons-deno.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDenoComponent ],
    exports:      [ SimpleIconsDenoComponent ],
    bootstrap:    []
})
export class SimpleIconsDenoModule {}
